import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
const TYPES = { installation: "Installation", referral: "Customer Referral", network: "Network", performance: "Performance", adjustment: "Adjustment" };

export default function ApplicatorEarnings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/applicator/earnings").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-500">Loading…</div>;
  const t = data.totals;

  return (
    <div data-testid="applicator-earnings-page">
      <h1 className="serif-head text-3xl lg:text-4xl mb-6">Earnings</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-testid="earnings-totals">
        {[["Total", t.total], ["Pending", t.pending], ["Payable", t.payable], ["Paid", t.paid]].map(([l, v]) => (
          <div key={l} className="hair-border bg-white/[0.02] p-5"><p className="errah-label mb-1">{l}</p><p className="font-display text-2xl gold-text">{money(v)}</p></div>
        ))}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-8" data-testid="earnings-bytype">
        {Object.entries(TYPES).map(([k, label]) => (
          <div key={k} className="hair-border bg-white/[0.02] p-4"><p className="errah-label mb-1">{label}</p><p className="font-display text-lg">{money(data.by_type[k])}</p></div>
        ))}
      </div>
      <p className="errah-label gold-text mb-3">Ledger</p>
      <div className="hair-border divide-y divide-white/10" data-testid="earnings-ledger">
        {data.ledger.length === 0 && <p className="p-4 text-sm text-gray-600">No transactions yet.</p>}
        {data.ledger.map((e) => (
          <div key={e.id} className="p-4 flex items-center justify-between bg-white/[0.02]">
            <div><p className="text-sm">{e.source}</p><p className="text-xs text-gray-500">{TYPES[e.type] || e.type}{e.level ? ` · L${e.level}` : ""} · {e.created_at?.slice(0, 10)} · {e.status}</p></div>
            <p className={`font-display ${e.status === "reversed" ? "line-through text-gray-500" : "gold-text"}`}>{money(e.amount)}</p>
          </div>
        ))}
      </div>
      <p className="mt-6 text-[11px] text-gray-600 max-w-2xl leading-relaxed">Earnings are based on eligible ERRĀH business activity and applicable programme terms. Past or sample earnings do not guarantee future results.</p>
    </div>
  );
}
